import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/Sara_Renters/subs.vtt';
import poster from '@/static/assets/reviews/Sara_Renters/video.jpg';

export const Sara: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Renters, ReviewProduct.All],
  reviewerName: 'Sara',
  videoUrl: `${ASSETS_URL}/renters/Sara_Renters.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
